export const VERIFICATION_BANNER_DISMISSED_KEY =
	"verification_banner_unverified_dismissed";
